import React from 'react'
import PropTypes from 'prop-types'

import { DataTable, Typography } from '@chilecompra/react-kit/components'

import { useAuthorization } from '../../containers/AuthorizationProvider/AuthorizationProvider.hooks'

import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { REDIRECT_PURCHASE_SHEET, PURCHASE_ORDER_SEARCHER_URL } from '../../config/settings/constants'

import { Grid, Link } from './QuoteListPurchaseOrder.styles'

/**
 * The Quote List Purchase Order's table.
 *
 */
const QuoteListPurchaseOrderTable = props => {
  const { loading, purchaseOrders } = props

  const { isBuyer } = useAuthorization()

  return (
    <Grid container spacing={2}>
      <Grid item>
        <DataTable
          accessibility={{ label: 'Órdenes de compra emitidas' }}
          headers={[
            { label: 'Orden de compra', value: 'code' },
            { label: 'Fecha de envío', value: 'date' },
            { label: 'RUT proveedor', value: 'supplierDni' },
            { label: 'Razón social', value: 'supplierLegalName' },
            { label: 'Monto total', value: 'amount' },
            { label: 'Estado', value: 'status' },
            isBuyer && { label: 'Acciones' }
          ]}
          headersCellsProps={[
            { enableSort: true },
            { enableSort: true, initialSort: true },
            { enableSort: true },
            { enableSort: true },
            { enableSort: true },
            { enableSort: true },
            isBuyer && { enableSort: false }
          ]}
          enableStripped
          loading={loading}
          records={purchaseOrders}
          recordsDecorators={[
            ({ code }) => (
              <Link
                href={REACT_APP_MERCADO_PUBLICO_BASE_URL.concat(REDIRECT_PURCHASE_SHEET).concat(code)}
                target="_blank"
                rel="noreferrer"
              >
                {code}
              </Link>
            ),
            ({ date }) => (
              <Typography variant="body2" lineHeight="18px" tabIndex="0">
                {date}
              </Typography>
            ),
            ({ supplierDni }) => (
              <Typography variant="body2" lineHeight="18px" tabIndex="0">
                {supplierDni}
              </Typography>
            ),
            ({ supplierLegalName }) => (
              <Typography variant="body2" lineHeight="18px" tabIndex="0">
                {supplierLegalName}
              </Typography>
            ),
            ({ amount }) => (
              <Typography variant="body2" lineHeight="18px" tabIndex="0">
                {amount}
              </Typography>
            ),
            ({ status }) => (
              <Typography variant="body2" lineHeight="18px" tabIndex="0">
                {status}
              </Typography>
            ),
            ({ code }) => {
              return (
                isBuyer && (
                  <Link
                    href={REACT_APP_MERCADO_PUBLICO_BASE_URL.concat(PURCHASE_ORDER_SEARCHER_URL).concat(
                      '?codigoOrdenCompra=' + code
                    )}
                    rel="noreferrer"
                  >
                    Gestionar OC
                  </Link>
                )
              )
            }
          ]}
        />
      </Grid>
    </Grid>
  )
}

QuoteListPurchaseOrderTable.propTypes = {
  loading: PropTypes.bool,
  purchaseOrders: PropTypes.arrayOf({
    code: PropTypes.string,
    date: PropTypes.string,
    supplierDni: PropTypes.string,
    supplierLegalName: PropTypes.string,
    amount: PropTypes.number,
    status: PropTypes.string
  })
}

export default QuoteListPurchaseOrderTable
